import root from 'window-or-global';

import env from 'env/env';
import { CLICK_ID_KEY, CONVERSION_KEY, CONVERSION_OPTIONS } from 'constants/impact';
import { getPageType } from 'utils/get-page-type';
import locator from 'utils/locator';
import { unstashObject } from 'utils/stash';
import { ORDER_CONFIRMATION } from 'constants/pageTypes';
import { log } from 'utils/error-logging';

export const trackConversion = () => {
  const pageType = getPageType(locator.pathname);
  const conversion =
    pageType === ORDER_CONFIRMATION && unstashObject(CONVERSION_KEY, { preserve: true });

  if (conversion) {
    const clickId = unstashObject(CLICK_ID_KEY, { preserve: true }) ?? '';
    const conversionWithClickId = { ...conversion, clickId, customProfileId: '' };

    // Send event using the Impact Radius Event API
    if (root.ire) {
      root.ire('trackConversion', env.impactTrackerId, conversionWithClickId, CONVERSION_OPTIONS);
    } else {
      log(new Error('Impact trackConversion attempted but root.ire unavailable'), {
        logger: 'impact-loader',
      });
    }
  }
};
